import React, { useEffect, useRef, useState } from "react";
import { Spin, Switch } from "antd";
import { ErrorMessage, Field, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import Select, { components } from "react-select";

import { Constants } from "../../Constants";
import { types } from "../../store/action_types";
import CustomTextInput from "../CustomTextInput";
import { UploadImage } from "../UploadImage";

const CustomOption = (props) => {
  return (
    <components.Option {...props}>
      <img
        src={props.data.iconImgUrl}
        alt=""
        style={{ width: 20, height: 20, marginRight: 10 }}
      />
      {props.data.symbol}
    </components.Option>
  );
};

const CustomSingleValue = (props) => {
  return (
    <components.SingleValue {...props}>
      <img
        src={props.data.iconImgUrl}
        alt=""
        style={{ width: 20, height: 20, marginRight: 10 }}
      />
      {props.data.symbol}
    </components.SingleValue>
  );
};

const AddOrEditTokens = ({
  handleCloseModal,
  isFirstTime,
  setIsFirstTime,
  currentPT,
  isEdit,
  page,
}) => {
  const { createLoading, editLoading } = useSelector(
    (state) => state.TokensReducer
  );
  const BoastImageLink = useSelector(
    (state) => state?.BoostReducer?.uploadBoastimageAllData?.result?.imgLink
  );
  const { blockchains } = useSelector((state) => state.BlockchainsReducer);
  const blockchainsArray = (blockchains && blockchains) || [];
  const loading = createLoading || editLoading;
  const [rewardObj, setRewardObj] = useState();
  const [imageFile, setImageFile] = useState(null);
  const formikRef = useRef();
  const dispatch = useDispatch();

  const handleResetForm = () => {
    setImageFile(null);
    formikRef.current.resetForm({
      values: {
        name: "",
        symbol: "",
        iconImgUrl: "",
        contractAddress: "",
        decimals: "",
        totalTokens: "",
        radius: "",
        withdrawFeeAmount: "",
        minWithdrawalAmount: "",
        cgId: "",
        priceInUsd: "",
        blockchain: "",
        status: "",
        worldwide: "",
        socialHub: "",
      },
    });
  };

  useEffect(() => {
    if (isEdit) {
      formikRef.current.setFieldValue("name", currentPT.name);
      formikRef.current.setFieldValue("symbol", currentPT.symbol);
      formikRef.current.setFieldValue("iconImgUrl", currentPT.iconImgUrl);
      formikRef.current.setFieldValue(
        "contractAddress",
        currentPT.contractAddress
      );
      formikRef.current.setFieldValue("decimals", currentPT.decimals);
      formikRef.current.setFieldValue("totalTokens", currentPT.totalTokens);
      formikRef.current.setFieldValue("radius", currentPT.radius);
      formikRef.current.setFieldValue("blockchain", currentPT.blockchain);
      formikRef.current.setFieldValue(
        "withdrawFeeAmount",
        currentPT.withdrawFeeAmount
      );
      formikRef.current.setFieldValue(
        "minWithdrawalAmount",
        currentPT.minWithdrawalAmount
      );
      formikRef.current.setFieldValue("cgId", currentPT.cgId);
      formikRef.current.setFieldValue("priceInUsd", currentPT.priceInUsd);
      formikRef.current.setFieldValue("status", currentPT.status === "active");
      formikRef.current.setFieldValue(
        "worldwide",
        currentPT.worldwide === "active"
      );
      formikRef.current.setFieldValue(
        "socialHub",
        currentPT.socialHub === "active"
      );
      setRewardObj(
        blockchainsArray.find((item) => item._id === currentPT?.blockchainId)
      );
    } else {
      formikRef.current.setFieldValue("name", "");
      formikRef.current.setFieldValue("symbol", "");
      formikRef.current.setFieldValue("iconImgUrl", "");
      formikRef.current.setFieldValue("contractAddress", "");
      formikRef.current.setFieldValue("decimals", "");
      formikRef.current.setFieldValue("totalTokens", "");
      formikRef.current.setFieldValue("radius", "");
      formikRef.current.setFieldValue("blockchain", "");
      formikRef.current.setFieldValue("withdrawFeeAmount", "");
      formikRef.current.setFieldValue("minWithdrawalAmount", "");
      formikRef.current.setFieldValue("cgId", "");
      formikRef.current.setFieldValue("priceInUsd", "");
      formikRef.current.setFieldValue("status", "");
      formikRef.current.setFieldValue("worldwide", "");
      formikRef.current.setFieldValue("socialHub", "");
      setRewardObj(null);
    }
    dispatch({
      type: types.GetBlockchainsRequest,
      payload: {
        searchText: "",
        page: 1,
      },
    });
  }, [currentPT]);

  return (
    <div>
      <div className="modaltitle">
        {`${isEdit ? "Edit" : "Add"}`} Partners Tokens
      </div>
      <Formik
        key="my-form"
        initialValues={{
          name: "",
          symbol: "",
          iconImgUrl: "",
          contractAddress: "",
          decimals: "",
          totalTokens: "",
          radius: "",
          blockchain: "",
          withdrawFeeAmount: "",
          minWithdrawalAmount: "",
          cgId: "",
          priceInUsd: "",
          status: "",
          worldwide: "",
          socialHub: "",
        }}
        enableReinitialize={false}
        innerRef={formikRef}
        validationSchema={Constants.AddTokensSchema}
        onSubmit={(values, { resetForm }) => {
          if (isEdit) {
            const updatedBody = {
              tokenId: currentPT._id,
              name: values.name,
              symbol: values.symbol,
              contractAddress: values.contractAddress,
              decimals: values.decimals,
              totalTokens: values.totalTokens,
              radius: values.radius,
              withdrawFeeAmount: values.withdrawFeeAmount,
              minWithdrawalAmount: values.minWithdrawalAmount,
              cgId: values.cgId,
              priceInUsd: values.priceInUsd,
              blockchain: values.blockchain,
              status: values.status ? "active" : "disable",
              worldwide: values.worldwide ? "active" : "disable",
              socialHub: values.socialHub ? "active" : "disable",
              blockchainId: rewardObj._id,
            };
            dispatch({
              type: types.EditTokensRequest,
              payload: {
                updatedBody,
                handleCloseModal: () => {
                  handleCloseModal();
                  resetForm();
                  setRewardObj(null);
                },
                page,
              },
            });
          } else {
            let formData = new FormData();
            formData.append("name", values.name);
            formData.append("symbol", values.symbol);
            formData.append("iconImgUrl", !!imageFile ? BoastImageLink : "");
            formData.append("contractAddress", values.contractAddress);
            formData.append("decimals", values.decimals);
            formData.append("totalTokens", values.totalTokens);
            formData.append("radius", values.radius);
            formData.append("withdrawFeeAmount", values.withdrawFeeAmount);
            formData.append("minWithdrawalAmount", values.minWithdrawalAmount);
            formData.append("cgId", values.cgId);
            formData.append("priceInUsd", values.priceInUsd);
            formData.append("blockchain", values.blockchain);
            formData.append("status", values.status ? "active" : "disable");
            formData.append(
              "worldwide",
              values.worldwide ? "active" : "disable"
            );
            formData.append(
              "socialHub",
              values.socialHub ? "active" : "disable"
            );
            formData.append("blockchainId", rewardObj._id);

            dispatch({
              type: types.CreateTokensRequest,
              payload: {
                formData,
                handleCloseModal: () => {
                  handleCloseModal();
                  resetForm();
                  setRewardObj(null);
                },
                page,
              },
            });
          }
        }}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          values,
          setFieldValue,
        }) => (
          <div className="formContainer">
            <div className="formHeader">
              <div className="formFields">
                <div
                  style={{
                    display: "flex",
                    gap: 32,
                    flexDirection: "row",
                  }}
                >
                  <UploadImage
                    setImageFile={setImageFile}
                    ErrorMessage={ErrorMessage}
                    setIsFirstTime={setIsFirstTime}
                    isFirstTime={isFirstTime}
                    formikRef={formikRef}
                    isEdit={isEdit}
                    currentPool={{ icon: currentPT?.iconImgUrl }}
                    loading={loading}
                  />
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-start",
                    }}
                  >
                    <Field name="symbol">
                      {({ meta }) => (
                        <CustomTextInput
                          label={"Symbol"}
                          type="text"
                          error={meta.touched ? meta.error : null}
                          onChange={(e) => {
                            if (e.target.value.length <= 75)
                              handleChange("symbol")(e);
                          }}
                          placeHolderText={"Enter symbol..."}
                          value={values.symbol}
                          onBlur={handleBlur("symbol")}
                          showEyeIcon={false}
                          required={true}
                          disable={loading}
                        />
                      )}
                    </Field>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "row",
                        gap: 24,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 4,
                          alignItems: "center",
                        }}
                      >
                        <label>Status*</label>
                        <Field name="status">
                          {() => (
                            <Switch
                              checked={values.status}
                              disabled={loading}
                              onChange={(checked) =>
                                setFieldValue("status", checked)
                              }
                            />
                          )}
                        </Field>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 4,
                          alignItems: "center",
                        }}
                      >
                        <label>Worldwide*</label>
                        <Field name="worldwide">
                          {() => (
                            <Switch
                              checked={values.worldwide}
                              disabled={loading}
                              onChange={(checked) =>
                                setFieldValue("worldwide", checked)
                              }
                            />
                          )}
                        </Field>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 4,
                          alignItems: "center",
                        }}
                      >
                        <label>SocialHub*</label>
                        <Field name="socialHub">
                          {() => (
                            <Switch
                              checked={values.socialHub}
                              disabled={loading}
                              onChange={(checked) =>
                                setFieldValue("socialHub", checked)
                              }
                            />
                          )}
                        </Field>
                      </div>
                    </div>
                  </div>
                </div>

                <Field name="name">
                  {({ meta }) => (
                    <CustomTextInput
                      label={"Name"}
                      type="text"
                      error={meta.touched ? meta.error : null}
                      onChange={(e) => {
                        if (e.target.value.length <= 25)
                          handleChange("name")(e);
                      }}
                      placeHolderText={"Enter name..."}
                      value={values.name}
                      onBlur={handleBlur("name")}
                      showEyeIcon={false}
                      required={true}
                      disable={loading}
                    />
                  )}
                </Field>
                <Field name="contractAddress">
                  {({ meta }) => (
                    <CustomTextInput
                      label={"Contract Address"}
                      type="text"
                      error={meta.touched ? meta.error : null}
                      onChange={(e) => {
                        if (e.target.value.length <= 75)
                          handleChange("contractAddress")(e);
                      }}
                      placeHolderText={"Enter contract Address..."}
                      value={values.contractAddress}
                      onBlur={handleBlur("contractAddress")}
                      showEyeIcon={false}
                      required={true}
                      disable={loading}
                    />
                  )}
                </Field>
                <div style={{ paddingBottom: 20 }}>
                  <label className="d-flex">Blockchain*</label>
                  <Select
                    onChange={(e) => {
                      setRewardObj(e);
                    }}
                    value={rewardObj}
                    placeholder="Select Blockchain..."
                    options={blockchainsArray}
                    getOptionLabel={(option) => option.symbol}
                    getOptionValue={(option) => option._id}
                    components={{
                      Option: CustomOption,
                      SingleValue: CustomSingleValue,
                    }}
                    styles={{
                      control: (base) => ({
                        ...base,
                        "&:hover": { borderColor: "black" },
                        border: "1px solid #9d895f",
                        borderRadius: "12px",
                        boxShadow: "none",
                      }),
                    }}
                    isDisabled={loading}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Field name="blockchain">
                    {({ meta }) => (
                      <CustomTextInput
                        label={"Blockchain type"}
                        type="text"
                        error={meta.touched ? meta.error : null}
                        onChange={(e) => {
                          if (e.target.value.length <= 75)
                            handleChange("blockchain")(e);
                        }}
                        placeHolderText={"Enter blockchain type..."}
                        value={values.blockchain}
                        onBlur={handleBlur("blockchain")}
                        showEyeIcon={false}
                        required={true}
                        disable={loading}
                      />
                    )}
                  </Field>
                  <Field name="decimals">
                    {({ meta }) => (
                      <CustomTextInput
                        label={"Decimals"}
                        type="number"
                        error={meta.touched ? meta.error : null}
                        onChange={(e) => {
                          if (e.target.value.length <= 75)
                            handleChange("decimals")(e);
                        }}
                        placeHolderText={"Enter decimals..."}
                        value={values.decimals}
                        onBlur={handleBlur("decimals")}
                        showEyeIcon={false}
                        required={true}
                        disable={loading}
                      />
                    )}
                  </Field>
                </div>

                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Field name="totalTokens">
                    {({ meta }) => (
                      <CustomTextInput
                        label={"Total Tokens"}
                        type="number"
                        error={meta.touched ? meta.error : null}
                        onChange={(e) => {
                          if (e.target.value.length <= 75)
                            handleChange("totalTokens")(e);
                        }}
                        placeHolderText={"Enter total Tokens..."}
                        value={values.totalTokens}
                        onBlur={handleBlur("totalTokens")}
                        showEyeIcon={false}
                        required={true}
                        disable={loading}
                      />
                    )}
                  </Field>
                  <Field name="radius">
                    {({ meta }) => (
                      <CustomTextInput
                        label={"Radius"}
                        type="number"
                        error={meta.touched ? meta.error : null}
                        onChange={(e) => {
                          if (e.target.value.length <= 75)
                            handleChange("radius")(e);
                        }}
                        placeHolderText={"Enter radius..."}
                        value={values.radius}
                        onBlur={handleBlur("radius")}
                        showEyeIcon={false}
                        required={true}
                        disable={loading}
                      />
                    )}
                  </Field>
                </div>

                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Field name="priceInUsd">
                    {({ meta }) => (
                      <CustomTextInput
                        label={"Price in USD"}
                        type="number"
                        error={meta.touched ? meta.error : null}
                        onChange={(e) => {
                          if (e.target.value.length <= 75)
                            handleChange("priceInUsd")(e);
                        }}
                        placeHolderText={"Enter price in USD..."}
                        value={values.priceInUsd}
                        onBlur={handleBlur("priceInUsd")}
                        showEyeIcon={false}
                        required={true}
                        disable={loading}
                      />
                    )}
                  </Field>
                  <Field name="withdrawFeeAmount">
                    {({ meta }) => (
                      <CustomTextInput
                        label={"Withdraw fee amount"}
                        type="number"
                        error={meta.touched ? meta.error : null}
                        onChange={(e) => {
                          if (e.target.value.length <= 100)
                            handleChange("withdrawFeeAmount")(e);
                        }}
                        placeHolderText={"Enter fee amount..."}
                        value={values.withdrawFeeAmount}
                        onBlur={handleBlur("withdrawFeeAmount")}
                        showEyeIcon={false}
                        required={true}
                        disable={loading}
                      />
                    )}
                  </Field>
                </div>
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Field name="cgId">
                    {({ meta }) => (
                      <CustomTextInput
                        label={"CoinGecko ID"}
                        type="string"
                        error={meta.touched ? meta.error : null}
                        onChange={(e) => {
                          if (e.target.value.length <= 100)
                            handleChange("cgId")(e);
                        }}
                        placeHolderText={"Enter CoinGecko ID..."}
                        value={values.cgId}
                        onBlur={handleBlur("cgId")}
                        showEyeIcon={false}
                        required={true}
                        disable={loading}
                      />
                    )}
                  </Field>
                  <Field name="minWithdrawalAmount">
                    {({ meta }) => (
                      <CustomTextInput
                        label={"Min withdrawal amount"}
                        type="number"
                        error={meta.touched ? meta.error : null}
                        onChange={(e) => {
                          if (e.target.value.length <= 100)
                            handleChange("minWithdrawalAmount")(e);
                        }}
                        placeHolderText={"Enter min amount..."}
                        value={values.minWithdrawalAmount}
                        onBlur={handleBlur("minWithdrawalAmount")}
                        showEyeIcon={false}
                        required={true}
                        disable={loading}
                      />
                    )}
                  </Field>
                </div>
              </div>
            </div>

            <div className="formFooter">
              <button
                type="submit"
                disabled={loading}
                className="addbtn border p1060"
                onClick={() => {
                  handleSubmit();
                }}
              >
                {loading && <Spin className="spin" />}
                {isEdit ? "Edit" : "Add"}
              </button>
              <button
                type="submit"
                disabled={loading}
                className="cancelbtn border p1060"
                onClick={() => {
                  if (!isEdit) {
                    handleResetForm();
                  }
                  handleCloseModal();
                  setRewardObj(null);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </Formik>
    </div>
  );
};

export default AddOrEditTokens;
